import React from "react";
import { getStatusColor } from "../../../Helper";
import { cartItemModel } from "../../../Interfaces";
import { orderSummaryProps } from "./orderSummaryProps";
import { useNavigate } from "react-router-dom";
import { SD_Roles, SD_Status } from "../../../Utility/SD";
import { RootState } from "../../../Storage/Redux/store";
import { useSelector } from "react-redux";
import { useState } from "react";
import { useUpdateOrderHeaderMutation } from "../../../Apis/orderApi";
import { MainLoader } from "../Common";

function OrderSummary({ data, userInput }: orderSummaryProps) {
  const badgeTypeColor = getStatusColor(data.status!);
  const navigate = useNavigate();
  const userData = useSelector((state: RootState) => state.userAuthStore);
  const [loading, setIsLoading] = useState(false);
  const [updateOrderHeader] = useUpdateOrderHeaderMutation();
  const path =window.location.pathname
  const nextStatus: any =
    data.status! === SD_Status.CONFIRMED
      ? { color: "info", value: SD_Status.BEING_COOKED }
      : data.status! === SD_Status.BEING_COOKED
      ? { color: "warning", value: SD_Status.READY_FOR_PICKUP }
      : data.status! === SD_Status.READY_FOR_PICKUP && {
          color: "success",
          value: SD_Status.COMPLETED,
        };

  const handleNextStatus = async () => {
    setIsLoading(true);
    await updateOrderHeader({
      orderHeaderId: data.id,
      status: nextStatus.value,
    });

    setIsLoading(false);
  };

  const handleCancel = async () => {
    setIsLoading(true);
    await updateOrderHeader({
      orderHeaderId: data.id,
      status: SD_Status.CANCELLED,
    });
    setIsLoading(false);
  };

  return (
    <div>
      {loading && <MainLoader />}
      {!loading && (
        <>
          <div className="d-flex justify-content-between align-items-center">
            <h3 className="text-success d-none d-md-block d-lg-block d-xl-block">Order Summary</h3>
            <h5 className="text-success mx-auto d-block d-md-none d-lg-none d-xl-none mt-2">Order Summary</h5>
            <span className={`btn btn-outline-${badgeTypeColor} fs-6`}>
              {data.status}
            </span>
          </div>
          <div className="mt-3">
            <div className="border py-3 px-2">Name : {userInput.name}</div>
            <div className="border py-3 px-2">Email : {userInput.email}</div>
            <div className="border py-3 px-2">
              Phone : {userInput.phoneNumber}
            </div>
            <div className="border py-3 px-2">
              <h4 className="text-success d-none d-md-block d-lg-block d-xl-block">Menu Items</h4>
              <h4 className="text-success text-center d-block d-md-none d-lg-none d-xl-none">Menu Items</h4>
              <div className="p-3">
                {data.cartItems?.map(
                  (cartItem: cartItemModel, index: number) => {
                    return (
                      <>
                      <div className="d-xl-flex d-none d-md-block d-lg-block d-xl-block" key={index}>
                        <div className="d-flex w-100 justify-content-between">
                          <p style={{ width: "40%"}}>{cartItem.menuItem?.name}</p>
                          <p style={{textAlign:"left"}}>
                          &#x20b9; {cartItem.menuItem?.price} x {cartItem.quantity} =
                          </p>
                        </div>
                        <p style={{ width: "70%", textAlign: "right" }}>
                        &#x20b9; 
                          {(cartItem.menuItem?.price ?? 0) *
                            (cartItem.quantity ?? 0)}
                        </p>
                      </div>
                      <div className="d-flex d-block d-md-none d-lg-none d-xl-none" key={index}>
                      <div className="d-flex w-100 justify-content-between">
                        <p style={{width: "40%"}}>{cartItem.menuItem?.name}</p>
                        <p>
                        &#x20b9; {cartItem.menuItem?.price} x {cartItem.quantity} =
                        </p>
                        <p style={{ textAlign: "right" }}>
                      &#x20b9; 
                        {(cartItem.menuItem?.price ?? 0) *
                          (cartItem.quantity ?? 0)}
                      </p>
                      </div>
                    </div>
                    </>
                    );
                  }
                )}

                <hr />
                <h4 className="text-danger" style={{ textAlign: "right" }}>
                &#x20b9; {data.cartTotal?.toFixed(2)}
                </h4>
              </div>
            </div>
          </div>
          {
              path.substring(0,18) === "/order/orderDetail"? 
              <>
              <br></br>
              <button className="btn btn-secondary d-block d-md-none d-lg-none d-xl-none" onClick={() => navigate(-1)}>
              Back to Orders
            </button>
              </>:
              <>
              </>
            }
          <div className="d-flex justify-content-between align-items-center mt-3">
            <button className="btn btn-secondary d-none d-md-block d-lg-block d-xl-block" onClick={() => navigate(-1)}>
              Back to Orders
            </button>
            {userData.role == SD_Roles.ADMIN && (
              <div className="d-flex">
                {data.status! !== SD_Status.CANCELLED &&
                  data.status! !== SD_Status.COMPLETED && (
                    <button
                      className="btn btn-danger mx-2"
                      onClick={handleCancel}
                    >
                      Cancel
                    </button>
                  )}
                <button
                  className={`btn btn-${nextStatus.color}`}
                  onClick={handleNextStatus}
                >
                  {nextStatus.value}
                </button>
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
}

export default OrderSummary;